import { Box } from "@mui/system"
import React from "react"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { Modal } from "./Modal"
import { Typography } from "./Typography"

type Props = {
  text: string
  confirmText: string
  cancelText: string
  confirmStyle?: any
  cancelStyle?: any
  open: boolean
  handleOpen: any
  handleConfirm: any
}

export const ConfirmModal: React.FC<Props> = ({
  text,
  confirmText,
  cancelText,
  confirmStyle,
  cancelStyle,
  open,
  handleOpen,
  handleConfirm,
}) => {
  const confirmSx = confirmStyle || {}
  const cancelSx = cancelStyle || {}

  const process = () => {
    handleOpen(false)
    handleConfirm()
  }

  return (
    <Modal open={open} onClose={() => handleOpen(false)}>
      <Box>
        <Typography.InputFieldTitle
          sx={{
            fontFamily: "Noto Sans JP !important",
            fontWeight: "700",
            ml: "10px",
            my: "auto",
          }}
        >
          {text}
        </Typography.InputFieldTitle>
        <Box display="flex" sx={{ mt: "30px" }}>
          <OutlinedButton
            caption={cancelText}
            fontColor="primary.main"
            fontWeight="700"
            sx={{
              borderColor: "primary.main",
              width: "150px",
              fontSize: "1rem",
              fontFamily: "Noto Sans JP !important",
              lineHeight: "1rem",
              fontWeight: 700,
              ml: "auto",
              display: "flex",
              justifyContent: "center",
              borderRadius: 0,
              ...cancelSx,
            }}
            onClick={() => handleOpen(false)}
          />
          <OutlinedButton
            caption={confirmText}
            fontColor={confirmSx.color ? confirmSx.color : "primary.main"}
            fontWeight="700"
            sx={{
              borderColor: "primary.main",
              width: "150px",
              fontSize: "1rem",
              fontFamily: "Noto Sans JP !important",
              lineHeight: "1rem",
              fontWeight: 700,
              ml: "20px",
              display: "flex",
              justifyContent: "center",
              borderRadius: 0,
              ...confirmSx,
            }}
            onClick={() => process()}
          />
        </Box>
      </Box>
    </Modal>
  )
}
